import * as React from 'react';
import { Link } from 'react-router-dom';

import { CategoryData } from '../App';
import { getPath, getCategoryLinkID } from './TemplateUtils';
import * as styles from '../css/CategorySidebar.less';
import { CategorySidebarList, CategorySidebarListItem, Divide, SidebarTitle } from '../styles/CategorySidebar';


interface CategorySidebarProps {
    categories: Array<CategoryData>;
    currentCategory?: CategoryData;
    basePath: string;
    categoryString: string;
}

export class CategorySidebar extends React.Component<CategorySidebarProps, any> {
    constructor(props: CategorySidebarProps) {
        super(props);
    }

    render() {
        return (
            <div className="sb-nav">
                <SidebarTitle className="h4 btm-18">{ this.props.categoryString }</SidebarTitle>
                <Divide className="btm-18" />
                <CategorySidebarList className="small">
                    { this.props.categories.map(category => {
                        const path = getPath(this.props.basePath, category.slug);
                        const sidebarID = getCategoryLinkID(category.slug, 'category-sidebar');

                        let itemStyleClassName = styles.categoryListItem;
                        if (this.props.currentCategory && category.slug === this.props.currentCategory.slug) {
                            itemStyleClassName = styles.catagorySelectedItem;
                        }
                        return <Link to={ path } key={ category.slug + '_link' } className={ itemStyleClassName + ' no-underline' }>
                            <CategorySidebarListItem id={ sidebarID } key={ category.slug + '_list' }>
                                { category.short_name }
                            </CategorySidebarListItem>
                        </Link>;
                    }) }
                </CategorySidebarList>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/CategorySidebar.tsx